import React from 'react';

const UsernameModal = ({ tempUsername, setTempUsername, onSave }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 p-4 flex items-center justify-center">
      <div className="bg-white w-full max-w-md rounded-2xl p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2 text-center">Welcome</h3>
        <p className="text-sm text-gray-600 mb-4 text-center">
          Enter a display name to post comments and discussion responses on this device.
        </p>
        <input
          type="text"
          value={tempUsername}
          onChange={(e) => setTempUsername(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onSave()}
          autoFocus
          placeholder="Enter your name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
        />
        <button
          onClick={onSave}
          disabled={!tempUsername.trim()}
          className="w-full py-2 rounded-lg bg-blue-600 text-white disabled:opacity-50"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default UsernameModal;
